import gql from 'graphql-tag';
const SELECT_IT_ACTIVITY_FRAGMENT = gql `
  fragment SelectItActivityFragment on SelectItActivity {
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
      }
    }
    rounds {
      hint {
        id
        audioId
        audio {
          id
          src
        }
      }
      roundInstructions: instructions {
        id
        audioId
        audio {
          id
          src
        }
      }
      roundImage: image {
        id
        imageId
        image {
          id
          src
        }
      }
      questionHtml {
        id
        elements
      }
      textHtml {
        id
        elements
      }
      answers {
        id
        startIndex
        endIndex
        correct
      }
    }
  }
`;
export default SELECT_IT_ACTIVITY_FRAGMENT;
